export const QuoteAircraftKey = Symbol("quote-aircraft");
export const QuoteLiabilityLimitKey = Symbol("quote-liability-limit");
export const QuoteHullValueKey = Symbol("quote-hull-value");
export const QuoteLineSizeKey = Symbol("quote-line-size");

export const AircraftClassKey = Symbol("aircraft-class");
export const AircraftFlightFiltersKey = Symbol("aircraft-flight-filters");
